import { isMobileApp } from 'hb-react/shared/utils/mobile';

export const getSocialProviderEnabled = (providerData) => {
  if (providerData.provider !== 'google') {
    return true;
  }

  return !(isMobileApp() || window.is_from_china);
};
